let env = process.env.NODE_ENV


if (env === 'development') {
  let host = 'localhost'
  module.exports = {
    // 主站 API 路径
    api: 'http://' + host + ':8080/api/v1',
    // 主站路径，和 API 域名相同
    host: 'http://' + host + ':8080',

    // iclass 网站路径，注意开发环境端口与主站不同
    publicPath: 'http://' + host + ':8081',

    // 消息服务器路径，注意与主站不同
    messageServer: 'http://' + host + ':50020',
    ojServer: 'http://' + host + ':50010'

  }
} else if (env === 'production') {
  let host = 'python123.io'
  module.exports = {
    api: 'https://' + host + '/api/v1',
    host: 'https://' + host,

    publicPath: 'https://' + host + '/iclass',
    messageServer: 'https://python123.io:50020',
    ojServer: 'https://python123.io:50010'
  }
}
